import { useState } from "react";
import { 
  Box, 
  Typography, 
  Button, 
  IconButton, 
  Menu, 
  MenuItem, 
  Divider, 
} from '@mui/material'


import AccountSettings from "../pages/account-settings";

import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

import { CircularProgress } from "@mui/material";

// icons / images
import logo from '../assets/icons/tpb-logo-black.svg'
import homeIcon from '../assets/icons/home.svg'
import userIcon from '../assets/icons/user.svg'


import config from "../twh/config";

const logoutUrl = config.reactApi_baseUrl + "/react-api/login/logout.php";


export default function Topbar({onToggleSidebar}) {

  const [syncLoading, setSyncLoading] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);


  const { userData } = useAuth();
  
  const wp_website_url = userData?.location?.selected?.websiteUrl;
  const wp_plugin_sync_url = config.reactApi_baseUrl + "/react-api/wp-plugin/sync.php"
  

  const navigate = useNavigate();

  
  const menuConfig = [
    {
      label: "Data Insights",
      children: [
        { path: "website-data", label: "Website Data" },
        { path: "advertising", label: "Advertising" },
        { path: "performance", label: "Performance" },
      ],
    },

    {
      label: "Website",
      children: [
        { path: "menu", label: "Menu" },
        { path: "file-menu", label: "PDF Menu" },
        { path: "opening-hours", label: "Opening Hours" },
        { path: "pop-up", label: "Pop Up" },
        { path: "color-scheme", label: "Color Scheme" },
        { path: "settings", label: "Website Settings" },
       
      ],
    },

    {
      label: "Marketing",
      children: [
        { path: "marketing/review-manager", label: "Review Manager" },
      ],
    },

   
    

    {
      label: "Settings",
      children: [
        { path: "integrations", label: "Integrations" },
        { path: "users", label: "Users" },
        { path: "account-billing", label: "Account Billing" },
      ],
    },

    {
      label: "Support",
      children: [
        { path: "faq", label: "FAQ" },
        { path: "contact", label: "Contact" },
      ],
    },
  ];

  const location = useLocation();
  const path = location.pathname.replace(/^\/+/, "");
  

  function getBreadcrumbs() {
    for (const menu of menuConfig) {
      if (menu.children) {
        for (const item of menu.children) {
          if (item.path === path) {
            return [menu.label, item.label];
          }
        }
      }
    }
    return ["Dashboard"];
  }

  const breadcrumbs = getBreadcrumbs();


  const handleSyncWebsite = async () => {
    const url = wp_plugin_sync_url;

    if (!url) return;

      try {
        setSyncLoading(true);

        await fetch(url, {
          method: "GET",
          credentials: "include",
        });

        // optional: success message bhi de sakte ho
        console.log("Sync completed");

      } catch (error) {
        console.error("Sync failed:", error);
      } finally {
        setSyncLoading(false);
      }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        height: 60,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#fff',

        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200, // sidebar se upar rahe
      }}
    >
      {/* LEFT SIDE */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <img src={logo} alt="Pixel Bakery" />
        {/*
        <IconButton onClick={onToggleSidebar}>
          <img src={homeIcon} width={14} />
        </IconButton>
        */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <img src={homeIcon} width={14} />

          {breadcrumbs.map((item, index) => (
            <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography fontSize={12} color="text.secondary">
                &gt;
              </Typography>

              <Typography
                fontSize={12}
                fontWeight={index === breadcrumbs.length - 1 ? 600 : 400}
              >
                {item}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {/* RIGHT SIDE */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Button
          variant="contained"
          size="small"
          href={wp_website_url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            backgroundColor: '#ff2c6d',
            textTransform: 'uppercase',
            fontSize: 11,
            px: 2,
            '&:hover': { backgroundColor: '#e52661' },
          }}
        >
          Visit Website
        </Button>

        <Button
          variant="contained"
          size="small"
          onClick={handleSyncWebsite}
          disabled={syncLoading}
          sx={{
            backgroundColor: '#0b1fae',
            textTransform: 'uppercase',
            fontSize: 12,
            px: 2,
            minWidth: 130,
            '&:hover': { backgroundColor: '#091a91' },
          }}
        >
          {syncLoading ? (
            <CircularProgress size={18} sx={{ color: '#fff' }} />
          ) : (
            "Sync Website"
          )}
        </Button>

        <Box
          onClick={handleMenuOpen}
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            '&:hover': { backgroundColor: '#dddddd' },
          }}
        >
          <img src={userIcon} width={14} />
        </Box>
        <Menu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            
            <Box sx={{backgroundColor:'#FF2C6D', p:1, color:'#fff', minWidth:200}}>
              <Box sx={{ fontSize: 10, fontWeight:'bold' }}>{userData?.userData?.firstName} {userData?.userData?.lastName}</Box>
              <Box sx={{ fontSize: 10, }}>{userData?.userData?.email}</Box>
              <Box>
                  <Box sx={{ fontSize: 10, background:'#fff', display:'inline-block', color:'#000', borderRadius:1, px:1 }}>{userData?.userData?.jobTitle}</Box>
              </Box>
            </Box>

            <MenuItem
              sx={{ fontSize: 12 }}
              onClick={() => {
                handleMenuClose();
                navigate("/account-settings"); 
              }}
            >
              Account Settings
            </MenuItem>

            <MenuItem
              sx={{ fontSize: 12, color:'red' }}
              component="a"
              href={logoutUrl}
            >
              Logout
            </MenuItem>
          </Menu>  


      </Box>
    </Box>
  )
}
